import { FC } from "react"
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material"
import { Userbot } from "../../interfaces"
import { stringifyJson } from "../common/jsonUtils"
import { blockBackdropClose } from "../common/dialogUtils"
import { summarizeCondition, isMatchAll } from "../fields/conditionExpr"
import { triggerReasonLabel } from "../common/trafficPolicy"

interface IProps {
  trigger: Userbot.Trigger
  onClose: () => void
}

const Row: FC<{ label: string; children: React.ReactNode }> = ({
  label,
  children,
}) => (
  <Box mt={1}>
    <Typography variant="subtitle2">{label}</Typography>
    <Typography variant="body2" color="text.secondary">
      {children}
    </Typography>
  </Box>
)

const formatNullableDate = (iso: string | null): string => {
  if (!iso) return "—"
  const d = new Date(iso)
  if (isNaN(d.getTime())) return iso
  return d.toLocaleString()
}

export const TriggerDetails: FC<IProps> = ({ trigger, onClose }) => (
  <Dialog open onClose={blockBackdropClose(onClose)} maxWidth="md" fullWidth>
    <DialogTitle>Триггер {trigger.type}</DialogTitle>
    <DialogContent>
      <Stack spacing={0}>
        <Row label="spawnDepth">{trigger.spawnDepth}</Row>
        <Row label="oneShot">{trigger.oneShot ? "да" : "нет"}</Row>
        <Row label="Активен">{trigger.isActive ? "да" : "нет"}</Row>
        <Row label="Причина недоступности">
          {triggerReasonLabel(trigger.nonExecutableReason)}
        </Row>
        <Row label="match">
          {isMatchAll(trigger.match)
            ? "совпадает со всеми"
            : summarizeCondition(trigger.match)}
        </Row>
        <Row label="inviteHash">{trigger.inviteHash ?? "—"}</Row>
        <Row label="Срабатываний">
          {trigger.fireCount}/{trigger.maxFires ?? "∞"}
        </Row>
        <Row label="Последнее срабатывание">
          {formatNullableDate(trigger.lastFiredAt)}
        </Row>
        <Row label="Истекает">{formatNullableDate(trigger.expiresAt)}</Row>
        <Box mt={2}>
          <Typography variant="subtitle2">chainTemplate</Typography>
          <pre style={{ fontFamily: "monospace", whiteSpace: "pre-wrap" }}>
            {stringifyJson(trigger.chainTemplate)}
          </pre>
        </Box>
      </Stack>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Закрыть</Button>
    </DialogActions>
  </Dialog>
)
